export default __webpack_public_path__ + "static/media/packages-offer.e363fbdd.png";